import React, { useState } from "react";
import JAS_LOGO from "../assets/JAS_LOGO.avif";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import { Button, Flex, Input, message, Modal } from "antd";
import PersonIcon from "@mui/icons-material/Person";
import { IconButton } from "@mui/material";
import { API } from "../config/auth";
import { useSelector } from "react-redux";

const Navbar = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const [profileModal, setProfileModal] = useState({
    open: false,
    data: null,
    loading: false,
    edit: false,
    btnLoading: false,
  });
  const organization_id = useSelector((state) => state.config.organization_id);

  const getProfileDetails = async () => {
    setProfileModal((prev) => ({ ...prev, open: true, loading: true }));

    await API.get(
      `/organization/get_organization?organization_id=${organization_id}`
    )
      .then((response) => {
        console.log(response.data);
        if (response?.data?.success) {
          setProfileModal((prev) => ({
            ...prev,
            data: response?.data?.data,
            loading: false,
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setProfileModal((prev) => ({ ...prev, loading: false }));
      });
  };

  const handleSaveProfileDetails = async () => {
    if (
      !profileModal?.data?.jas_client_id ||
      !profileModal?.data?.jas_client_secret
    ) {
      return messageApi.error("Please enter the details!");
    }

    setProfileModal((prev) => ({ ...prev, btnLoading: true }));

    let data = {
      organization_id: window.localStorage.getItem("organization_id"),
      updates: {
        auth_type: "JAS",
        client_id: profileModal?.data?.jas_client_id,
        client_secret: profileModal?.data?.jas_client_secret,
      },
      update_type: "auth_details",
    };

    await API.patch(`/organization/update_organization`, data)
      .then((response) => {
        console.log(response.data);
        if (response.data?.success) {
          messageApi.success("Data updated successfully!");
          setProfileModal((prev) => ({
            ...prev,
            btnLoading: false,
            open: false,
          }));
        }

        messageApi.error("Error occurred!!");
      })
      .catch((error) => {
        messageApi.error("Error occurred!!");

        console.log(error);
      });
  };

  return (
    <nav className="nav">
      {contextHolder}

      <Modal
        open={profileModal?.open}
        centered
        title="Profile Details"
        footer={false}
        onCancel={() => {
          setProfileModal((prev) => ({ ...prev, open: false }));
        }}
        loading={profileModal?.loading}
        maskClosable={false}
      >
        <Flex vertical gap={16}>
          <div></div>
          <Flex gap={16} align="center">
            <label htmlFor="email" className="profile_label">
              Email
            </label>
            <Input
              id="email"
              value={profileModal?.data?.email}
              bordered={false}
              readOnly
            />
          </Flex>

          <Flex gap={16} align="center">
            <label htmlFor="extension_number" className="profile_label">
              Ext Number
            </label>
            <Input
              id="extension_number"
              value={profileModal?.data?.extension_number}
              bordered={false}
              readOnly
            />
          </Flex>

          <Flex gap={16} align="center">
            <label htmlFor="jas_client_id" className="profile_label">
              JAS Client ID
            </label>
            <Input
              id="jas_client_id"
              name="jas_client_id"
              value={profileModal?.data?.jas_client_id}
              onChange={(e) => {
                const { name, value } = e.target;

                setProfileModal((prev) => ({
                  ...prev,
                  data: { ...prev?.data, [name]: value },
                }));
              }}
            />
          </Flex>

          <Flex gap={16} align="center">
            <label htmlFor="jas_client_secret" className="profile_label">
              JAS Client Secret
            </label>
            <Input
              id="jas_client_secret"
              name="jas_client_secret"
              value={profileModal?.data?.jas_client_secret}
              onChange={(e) => {
                const { name, value } = e.target;

                setProfileModal((prev) => ({
                  ...prev,
                  data: { ...prev?.data, [name]: value },
                }));
              }}
            />
          </Flex>

          <Flex gap={16} align="center" justify="center">
            <Button
              type="primary"
              size="small"
              loading={profileModal?.btnLoading}
              onClick={handleSaveProfileDetails}
            >
              Save
            </Button>
            <Button size="small">Cancel</Button>
          </Flex>
        </Flex>
      </Modal>

      <div></div>
      <img src={JAS_LOGO} alt="" />

      <Flex gap={16}>
        <IconButton>
          <PhoneEnabledIcon />
        </IconButton>
        <IconButton onClick={getProfileDetails}>
          <PersonIcon />
        </IconButton>
      </Flex>
    </nav>
  );
};

export default Navbar;
